import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Grid from '@mui/material/Grid'
import { Form, Formik } from 'formik'
import { AppDispatch, RootState } from 'redux/store'
import { setAcademicYear, setGradeLevel, setGroup, setStudent, setGroupCourse } from 'redux/ui/groupCourseGradebookUI'
import { academicYearSelectData, downloadFile, gradeSelectData } from 'utils/helpers'
import SelectField from 'components/atoms/fields/SelectField'
import formModel, { initialValues } from 'utils/tableFilterModels/groupCourseGradebookTableFilterModel'
import { useGET_groupCourseSelectQuery } from 'redux/api/groupCoursesApi'
import { useGET_groupSelectQuery } from 'redux/api/groupsApi'
import { useGET_studentsProfileSelectQuery } from 'redux/api/studentsApi'
import { FaFileDownload } from 'react-icons/fa'
import { PRIMARY_ORANGE, PURE_BLACK } from 'utils/customizedTheme'
import { useTranslation } from 'react-i18next'


interface IProps {
  student?: string
}

const StudentGradebookFilters: FC<IProps> = ({student=null}) => {
  const reduxKey = 'groupCourseGradebook';
  const dispatch = useDispatch<AppDispatch>()
  const { t } = useTranslation()
  
  const { academic_year, grade_level, group, student: filter_student, group_course } = formModel()
  const ui_student =  useSelector((state: RootState) => state[reduxKey].tableFilters.student)
  const selectedStudent = student || ui_student

  return (
    <>
      <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={(values) => { 

          }}>
            {({ values, setFieldValue }) => (
            <Form>
              <Grid container spacing={2}>

                    <Grid item xs={12} lg={2}>
                      <SelectField
                        fieldProps={{ ...academic_year }}
                        apiCall={academicYearSelectData}
                        onChange={(value) => {
                            setFieldValue('grade_level', null)
                            setFieldValue('group', null)
                            setFieldValue('student', null)
                            setFieldValue('group_course', null)
                            dispatch(setAcademicYear(value?.id ?? null))
                            dispatch(setGradeLevel(null))
                            dispatch(setGroup(null))
                            dispatch(setStudent(null))
                            dispatch(setGroupCourse(null))
                        }}
                      />
                    </Grid> 

                    { !student && values?.academic_year &&
                          <Grid item xs={6} lg={2}>
                              <SelectField
                                fieldProps={{ ...grade_level }}
                                apiCall={gradeSelectData}
                                onChange={(value) => {
                                  setFieldValue('group', null)
                                  setFieldValue('student', null)
                                  setFieldValue('group_course', null)
                                  dispatch(setGradeLevel(value?.id ?? null))
                                  dispatch(setGroup(null))
                                  dispatch(setStudent(null))
                                  dispatch(setGroupCourse(null))
                                }}
                              />
                          </Grid> 
                    }

                    {  !student && values?.grade_level &&
                        <Grid item xs={6} lg={2}>
                            <SelectField
                              fieldProps={{ ...group }}
                              apiCall={useGET_groupSelectQuery}
                              filters={{
                                academic_year: values?.academic_year?.id, 
                                grade_level: values?.grade_level?.id
                              }}
                              onChange={(value) => {
                                setFieldValue('student', null)
                                setFieldValue('group_course', null)
                                dispatch(setGroup(value?.id ?? null))
                                dispatch(setStudent(null))
                                dispatch(setGroupCourse(null))
                              }}
                            />
                        </Grid> 
                    }

                   { !student && values?.group &&
                        <Grid item xs={6} lg={3}>
                            <SelectField
                              fieldProps={{ ...filter_student }}
                              apiCall={useGET_studentsProfileSelectQuery}
                              filters={{
                                grade_level: values?.grade_level?.id,
                                group: values?.group?.id, 
                              }}
                              onChange={(value) => {
                                setFieldValue('group_course', null)
                                dispatch(setStudent(value?.id ?? null))
                                dispatch(setGroupCourse(null))
                              }}
                            />
                        </Grid> 
                    }

                  { selectedStudent &&   
                   <Grid item xs={12} lg={3}>
                      <SelectField
                        fieldProps={{ ...group_course }}
                        filters={{
                          student: selectedStudent
                        }}
                        apiCall={useGET_groupCourseSelectQuery}
                        onChange={(value) => {
                            dispatch(setGroupCourse(value?.id ?? null))
                        }}
                      />
                   </Grid> 
                  }

                  {selectedStudent && <Grid item xs={12} sx={{ textAlign: 'right' }}>
                      <span onClick={() => {
                         if(values?.academic_year){
                           downloadFile(`/gradebook-grid-download-report/${values?.academic_year.id}/`, {
                              student_id: selectedStudent || '',
                            })
                          }
                      }} style={{  display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}>

                          <FaFileDownload color={PRIMARY_ORANGE}/> 
                          <span style={{ marginLeft: '5px', color: PURE_BLACK, fontSize: '12px', textDecoration: 'underline' }}>
                            {t('common.download-detailed-report')}</span>
                      </span>
                    </Grid>}

              </Grid>
            </Form>
          )}
      </Formik>
    </>
  )
}
export default StudentGradebookFilters